import React, {Fragment, useState} from 'react';
import Box from '../layout/Box';
import createEditor from '../form/ComponentEditor';
import SelectorGrid from "../form/SelectorGrid/SelectorGrid";
import {SelectButton} from "primereact/selectbutton";
import {CurrencyFormatter, ProductColumn, productTooltip, UnitFormatter} from "../../utils/formatters";
import BoxEditor from "./BoxEditor";
import Confirm from "../form/Confirm";
import TextInput from "../form/TextInput";
import {postData} from "../../utils/request";
import {connect} from "src/store";
import Select from "../form/Select";
import ComponentEditor from "src/components/form/ComponentEditor/ComponentEditor";

const Arrows = connect((state) => {
    return {
        user: state.app.user,
    }
})(({user, row, processAction, refresh, isLoading}) => {
    const [shortage, setShortage] = useState(null);
    const [surplus, setSurplus] = useState(null);
    if (!user.hasPermission("manual_stock_modification")) {
        return null;
    }
    return <Fragment>
        <Confirm
            header="Hiányba"
            body={<Fragment>
                <div className="form-group unit">
                    <TextInput
                        label={false}
                        disabled={isLoading}
                        type="number"
                        name="shortage"
                        formatter={UnitFormatter}
                        value={shortage}
                        saveChanges={(field, value) => setShortage(value ? parseInt(value) : value)}
                    />
                </div>
            </Fragment>}
            buttonSize="xs"
            color="warning"
            acceptAble={!!shortage}
            tooltip="Hiányba"
            onAccept={async () => {
                await processAction(async () => {
                    const response = await postData({
                        action: 'store.addShortage',
                        id: row.store.id,
                        data: {product_id: row.product_id, qty: shortage}
                    });
                    refresh && refresh(shortage);
                    return response;
                });
            }}
            icon={{lib: "fas", name: "arrow-right"}}
        >
        </Confirm>
        <Confirm
            header="Készletre"
            body={<Fragment>
                <div className="form-group unit">
                    <TextInput
                        label={false}
                        disabled={isLoading}
                        type="number"
                        name="surplus"
                        formatter={UnitFormatter}
                        value={surplus}
                        saveChanges={(field, value) => setSurplus(value ? parseInt(value) : value)}
                    />
                </div>
            </Fragment>}
            buttonSize="xs"
            color="warning"
            acceptAble={!!surplus}
            tooltip="Készletre"
            onAccept={async () => {
                await processAction(async () => {
                    const response = await postData({
                        action: 'store.addSurplus',
                        id: row.store.id,
                        data: {product_id: row.product_id, qty: surplus}
                    });
                    refresh && refresh(-surplus);
                    return response;
                });
            }}
            icon={{lib: "fas", name: "arrow-left"}}
        >
        </Confirm>
    </Fragment>;
});

export class stockEditor extends React.Component {

    state = {
        filter: ["store"],
        shadowStockModal: {}
    };

    render() {
        const List = this.props.list || Box;
        const Editor = this.props.editor || BoxEditor;
        const sortable = true;
        const filterable = true;
        let columns = [];
        let filters = [];
        let filter = [];
        let stockButton = null;
        if (this.props.product_id === undefined) {
            filters = [
                {label: 'Raktáranként', value: "store", filter: {field: "store", operator: "not isnull"}}
            ];
            stockButton = this.props.user.hasPermission("manual_stock_modification") && <Confirm
                color="warning"
                header="Készletre"
                body={<Fragment>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="form-group">
                                <Select
                                    label="Raktár"
                                    name="store"
                                    value={this.state.shadowStockModal.store}
                                    storeType="local"
                                    component="location"
                                    objectValue={false}
                                    filter={[{field: "partner", value: this.props.context.partner.partner_id}]}
                                    saveChanges={(field, value) => {
                                        this.setState({shadowStockModal: {...this.state.shadowStockModal, [field]: value}});
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="form-group">
                                <Select
                                    label="Termék"
                                    name="product"
                                    value={this.state.shadowStockModal.product}
                                    storeType="remote"
                                    placeholder="Vonalkód vagy cím"
                                    component="product"
                                    objectValue={false}
                                    saveChanges={(field, value) => {
                                        this.setState({shadowStockModal: {...this.state.shadowStockModal, [field]: value}});
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-md-12">
                            <div className="form-group unit">
                                <TextInput
                                    label="Mennyiség"
                                    type="number"
                                    name="qty"
                                    value={this.state.shadowStockModal.qty}
                                    formatter={UnitFormatter}
                                    saveChanges={(field, value) => {
                                        this.setState({shadowStockModal: {...this.state.shadowStockModal, [field]: value}});
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </Fragment>}
                acceptAble={!!this.state.shadowStockModal.store && !!this.state.shadowStockModal.product && !!this.state.shadowStockModal.qty}
                onAccept={async () => {
                    await this.props.processAction(async () => {
                        const response = await postData({
                            action: 'store.addSurplus',
                            id: this.state.shadowStockModal.store,
                            data: {product_id: this.state.shadowStockModal.product, qty: this.state.shadowStockModal.qty}
                        });
                        this.setState({shadowStockModal: {}});
                        this.list && this.list.refresh();
                        return response;
                    });
                }}
            >
                Készletre
            </Confirm>;
            columns = {
                "base_product_id": {
                    header: 'Árukód',
                    width: 1,
                    sortable,
                    filterable
                },
                "displayname": {
                    ...ProductColumn("product_id"),
                    width: 3,
                },
                "category.name": {
                    header: 'Árutípus',
                    width: 1,
                    sortable,
                    filterable
                },
                "tradename.name": {
                    header: 'Kiadó',
                    width: 1,
                    sortable,
                    filterable
                },
                "series.title": {
                    header: 'Sorozat',
                    width: 1,
                    sortable,
                    filterable
                },
                "sku": {
                    header: 'ISBN',
                    sortable,
                    filterable
                },
                "barcode": {
                    header: 'Vonalkód',
                    sortable,
                    filterable
                },
                "listprice": {
                    header: 'Listaár',
                    sortable,
                    filterable,
                    className: "currency",
                    renderer: CurrencyFormatter
                },
                "qty": {
                    header: 'Darabszám',
                    sortable,
                    filterable,
                    renderer: (value, row) => UnitFormatter(value, row.unit),
                    className: "unit"
                },
                ...(this.props.user.hasPermission("manual_stock_modification") ? {"shadowqty_move": {
                    header: ' ',
                    width: 'cell-button',
                    renderer: (value, row, rowIndex, props, parent) => <Arrows
                        isLoading={this.props.isLoading}
                        refresh={(qty) => {
                            parent.onEditorValueChange({...props, fieldName: "shadow"}, qty);
                        }}
                        value={value}
                        row={row}
                        processAction={this.props.processAction}
                    />
                }} : {}),
                "shadowqty_shortage": {
                    header: 'Hiány',
                    //sortable,
                    //filterable,
                    renderer: (value, row) => row.shadowqty > 0 ? UnitFormatter(row.shadowqty || 0, row.unit) : null,
                    className: "unit"
                },
                "shadowqty_surplus": {
                    header: 'Többlet',
                    //sortable,
                    //filterable,
                    renderer: (value, row) => row.shadowqty < 0 ? UnitFormatter(Math.abs(row.shadowqty || 0), row.unit) : null,
                    className: "unit"
                },
                "partner.name": {
                    header: 'Partner',
                    width: 2,
                    sortable,
                    filterable
                },
                "store.name": {
                    header: 'Raktár',
                    width: 2,
                    sortable,
                    filterable
                },
                /*"authors": {header: 'Szerzők', width: 1, renderer: (authors) => {
                    return authors.map((author) => author.name).reduce((prev, curr) => [prev, prev ? ', ' : '', curr], null)
                }}*/
                ...(this.props.plusColumns || {})
            };
            filter = filters.filter((item) => this.state.filter.indexOf(item.value) !== -1).map((item) => item.filter);
            if (!filter.length) {
                filter = [{field: "partner", operator: "not isnull"}];
                delete columns["store.name"];
            }
            if (this.props.store_id && this.props.store_id.length) {
                filter = [
                    ...filter,
                    Array.isArray(this.props.store_id)
                        ?
                        {
                            field: "store",
                            value: this.props.store_id.map(store => store.id),
                            operator: "in"
                        }
                        :
                        {
                            field: "store",
                            value: this.props.store_id,
                            operator: "="
                        }
                ];
            }
        } else {
            columns = {
                //"id": {width: 1, sortable, filterable},
                "displayname": {
                    header: 'Név',
                    width: 3,
                    sortable,
                    filterable,
                    tooltip: productTooltip("product_id")
                },
                "category.name": {
                    header: 'Árutípus',
                    width: 1,
                    sortable,
                    filterable
                },
                "tradename.name": {
                    header: 'Kiadó',
                    width: 1,
                    sortable,
                    filterable
                },
                "sku": {
                    header: 'ISBN',
                    width: 2,
                    sortable,
                    filterable
                },
                "barcode": {
                    header: 'Vonalkód',
                    width: 2,
                    sortable,
                    filterable
                },
                "listprice": {
                    header: 'Listaár',
                    width: 2,
                    sortable,
                    filterable,
                    className: "currency",
                    renderer: CurrencyFormatter
                },
                "qty": {
                    header: 'Darabszám',
                    width: 2,
                    sortable,
                    filterable,
                    renderer: (value, row) => UnitFormatter(value || 0, row.unit),
                    className: "unit"
                },
                "store.name": {
                    header: 'Raktár',
                    width: 2,
                    sortable,
                    filterable
                },
                /*"authors": {header: 'Szerzők', width: 1, renderer: (authors) => {
                    return authors.map((author) => author.name).reduce((prev, curr) => [prev, prev ? ', ' : '', curr], null)
                }}*/
                ...(this.props.plusColumns || {})
            };
            filter = [
                {field: "store", operator: "not isnull"},
            ];
            if (this.props.store_id) {
                filter = [...filter, {field: "store", value: this.props.store_id, operator: "!="}];
            }
        }
        if (this.props.product_id) {
            filter.push({field: "id", value: this.props.product_id});
        }
        if (this.props.partner_id) {
            filter.push({field: "partner", value: this.props.partner_id, operator: Array.isArray(this.props.partner_id) ? "in" : "="});
        }
        filter = [...filter, {field: "qty", value: 0, operator: "!="}];
        return (
            <Fragment>
                <List
                    theme="default"
                    header={"Készlet lista"}
                    actions={this.props.product_id === undefined && <SelectButton value={this.state.filter} multiple={true} options={filters} onChange={(e) => this.setState({filter: e.value})} />}
                    footer={stockButton}
                >
                    <SelectorGrid
                        ref={(el) => this.list = el}
                        gridid={this.props.gridid !== undefined ? this.props.gridid : "stockList"}
                        loading={this.props.isLoading}
                        componentConfig={this.props.componentConfig}
                        view={[...Object.keys(columns), "product_id", "store.id", "partner.partner_id", "shadowqty"]}
                        exports={[
                            {as: "excel", label: "Excel", icon: "far fa-file-excel", addFilters: true, browserExport: {type: "excel", filename: "készlet.xlsx", order: {field: "store", direction: "ASC"}}},
                            {as: "excel", label: "Megrendeléshez", icon: "far fa-file-excel", view: ["displayname", "barcode", "listprice"], labels: {displayname: "Cím", barcode: "Vonalkód", listprice: "Fogyasztói ár"}, addFilters: true, browserExport: {type: "excel", filename: "pagony_megrendeles.xlsx", order: {field: "store", direction: "ASC"}}}
                        ]}
                        aggregations={{
                            fields: {
                                "qty": {
                                    field: "qty", type: "SUM"
                                }
                            }
                        }}
                        columns={columns}
                        filter={filter}
                        actions={true}
                        onItemUpdate={(item, oldItem, fieldName, rowIndex) => {
                            if (fieldName === "shadow") {
                                item["shadowqty"] = parseInt(item["shadowqty"] || 0) + parseInt(item[fieldName] || 0);
                                item["qty"] = parseInt(item["qty"] || 0) - parseInt(item[fieldName] || 0);
                                delete item.shadow;
                            }
                            return item;
                        }}
                        // kell az id mivel nincs idfield...
                        orderBy={{field: "id", direction: "DESC"}}
                        /*onSort={(field, direction) => {
                            if (field === "shadowqty_surplus" || field === "shadowqty_shortage") {
                                return {
                                    field: "shadowqty",
                                    direction
                                }
                            }
                        }}*/
                    />
                </List>
            </Fragment>
        );
    }
}
export default connect((state) => {
    return {
        user: state.app.user,
        context: state.app.context,
    }
})((props) => {
    const Editor = stockEditor;
    return <ComponentEditor
        componentName="StockItem"
        editorContext="stock"
        {...props}
    >
        <Editor />
    </ComponentEditor>
});

